<template>
  <Search
    :url="url"
    :title="$lang.searchCompetency"
    :remove_item="remove_item"
    config="competency"
    toggleable="true"
    removeModalSize="xl"
    addModalSize="lg"
  >
    <template slot="addModal" slot-scope="search">
      <AddCompetency isModal @modal-end-up="search.close"></AddCompetency>
    </template>
  </Search>
</template>

<script>
import Search from "@/components/base/search";
import AddCompetency from "../competency/addCompetency";

export default {
  components: { Search, AddCompetency },
  data() {
    return {
      loadingItem: false,
      url: this.$config.api_url + this.$config.kanoon.competency,
    };
  },
  methods: {
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
  },
};
</script>
